let cookieName = 'newsletter-cookie';

(function () {
  document.addEventListener('DOMContentLoaded', function (e) {

    var faqItems = document.querySelectorAll('.faq__title')

    faqItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        item.classList.toggle('faq__title--active')
        Array.prototype.filter.call(faqItems, function (oldItem) {
          return oldItem !== item
        }).forEach(function (oldItem) {
          oldItem.classList.remove('faq__title--active')
        })
      })
    })

    resetPasswordSuccess()

    objectFitImages()
    document.querySelectorAll('img', img => {
      img.addEventListener('load', e => {
        objectFitImages(img)
      })
    })
  })

  let closeNewsletterModal = document.getElementById('close-modal');
  let modalContainer = document.getElementById('modal-container');
  let formSuccessIndicator = document.getElementById('form-success-indicator');

  if (formSuccessIndicator) {
    modalContainer.style.display = 'block';
  } else if(readCookie(cookieName) == null || readCookie(cookieName) == false) {
    window.newsletterTimeout = setTimeout(function() {
      modalContainer.style.display = 'block';
    }, 20000)
  } else {
    modalContainer.style.display = 'none';
  }

  closeNewsletterModal.addEventListener('click', () => {
    modalContainer.style.display = 'none';
    createCookie(cookieName, 'true', 28);
  })

  const closePromoPopup = document.getElementById('collection-promo-popup-close')
  const promoPopup = document.getElementById('collection-promo-popup')

  const popupClosed = (() => {
    try {
      return window.sessionStorage.getItem(`collection-promo-popup-${window.collection_handle}-closed`)
    } catch (err) {
      console.error(err)
    }
  })()

  if (!popupClosed && promoPopup) {
    setTimeout(function () {
      clearTimeout(window.newsletterTimeout)
      promoPopup.setAttribute('aria-hidden', 'false')
    }, 1000)

    if (closePromoPopup) {
      closePromoPopup.addEventListener('click', function () {
        promoPopup.setAttribute('aria-hidden', 'true')

        try {
          window.sessionStorage.setItem(`collection-promo-popup-${window.collection_handle}-closed`, true)
        } catch (err) {
          console.error(err)
        }
      })
    }
  }
})()

function resetPasswordSuccess() {
  if (location.pathname !== '/account/login') {
    return
  }

  var submitted = document.querySelector('.reset-password-success')
  console.log(submitted)
  if (submitted) {
    document.querySelector('#success').style.display = 'block'
  }
}

function initMap() {
  var maps = document.querySelectorAll('.map')
  maps.forEach(function (mapContainer) {
    var coordinates = {
      lat: parseFloat(mapContainer.dataset.lat),
      lng: parseFloat(mapContainer.dataset.lng)
    }

    var map = new google.maps.Map(mapContainer, {
      center: coordinates,
      zoom: 15
    })

    var marker = new window.google.maps.Marker({
      position: coordinates,
      map: map
    })
  })
}

(function () {
  document.addEventListener('DOMContentLoaded', function (e) {
    swatchModal = document.querySelector('.swatch-modal')
    swatchModalWrapper = document.querySelector('.swatch-modal__wrapper')
    swatchModalClose = document.querySelector('.swatch-modal__close')
    swatchModalTrigger = document.querySelector('.swatch-modal-trigger')

    if (swatchModalTrigger) {
      swatchModalTrigger.addEventListener('click', e => {
        document.body.classList.add('swatch-modal-open')
      })
    }
   
    if (swatchModalClose) {
      swatchModalClose.addEventListener('click', e => {
        e.target.blur()
        document.body.classList.remove('swatch-modal-open')
      })
    }

    if (swatchModalClose) {
      swatchModal.addEventListener('click', e => {
        document.body.classList.remove('swatch-modal-open')
      })
    }

    if (swatchModalWrapper) {
    swatchModalWrapper.addEventListener('click', e => e.stopPropagation())
    }
  })
})()


//Handle Cookies
function createCookie(name, value, days) {
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
  }
  else var expires = "";               

  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}
